// extracted by mini-css-extract-plugin
module.exports = {"logo":"header_logo__3T9bz","headerWrapper":"header_headerWrapper__399Ng","navigationWrapper":"header_navigationWrapper__312wr","search":"header_search__1McTJ"};